export var MeterType;
(function (MeterType) {
    MeterType[MeterType["Option1"] = 1] = "Option1";
    MeterType[MeterType["Option2"] = 2] = "Option2";
    MeterType[MeterType["Option3"] = 3] = "Option3";
    MeterType[MeterType["Option4"] = 4] = "Option4";
    MeterType[MeterType["Option5"] = 5] = "Option5";
    MeterType[MeterType["Option6"] = 6] = "Option6";
    MeterType[MeterType["Option7"] = 7] = "Option7";
    MeterType[MeterType["Option8"] = 8] = "Option8";
    MeterType[MeterType["Option9"] = 9] = "Option9";
    MeterType[MeterType["Option10"] = 10] = "Option10";
    MeterType[MeterType["Option11"] = 11] = "Option11";
    MeterType[MeterType["Option12"] = 12] = "Option12";
    MeterType[MeterType["Option13"] = 13] = "Option13";
    MeterType[MeterType["Own"] = 14] = "Own";
})(MeterType || (MeterType = {}));
